import React from "react";
import { PlanUsageLogCard } from "./PlanUsageLogCard";

export function PlanUsageLogPage({ history }) {
  return <PlanUsageLogCard />;
}
